import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ComingSoon from './ComingSoon';

// Suppress UNSAFE lifecycle warnings in development
const originalConsoleError = console.error;
console.error = (...args) => {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('UNSAFE_componentWillMount')) {
    return;
  }
  originalConsoleError.apply(console, args);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const isComingSoon = process.env.REACT_APP_COMING_SOON === 'true';

root.render(
  <React.StrictMode>
    {isComingSoon ? <ComingSoon /> : <App />}
  </React.StrictMode>
);
